import { useEffect, useRef, type ReactNode } from 'react';
import { useT } from '../i18n';

export function Modal({ title, onClose, children, full }: { title: string; onClose: () => void; children: ReactNode; full?: boolean }) {
  const t = useT();
  const ref = useRef<HTMLDivElement>(null);
  // Callers pass inline handlers; keep the latest in a ref so the focus setup below runs once, not on every render.
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const prev = document.activeElement as HTMLElement | null;
    // Don't steal focus from a field that already claimed it (e.g. autoFocus).
    if (!ref.current?.contains(document.activeElement)) ref.current?.focus();
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && close.current();
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      prev?.focus?.();
    };
  }, []);
  return (
    <div className="backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div ref={ref} tabIndex={-1} role="dialog" aria-modal="true" aria-label={title} className={`dialog ${full ? 'full' : ''}`}>
        <div className="row" style={{ justifyContent: 'space-between', marginBottom: 16 }}>
          <h2 style={{ fontSize: 28 }}>{title}</h2>
          <button className="btn btn-ghost" type="button" onClick={onClose} aria-label={t.common.close}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}
